import { useCohortListQuery } from '@verantos-dev/data-access-cohorts';

import { useAnalysisRouteParams } from './useAnalysisRouteParams';
import { selectCohortProfileId, selectLoadedVersionId } from '../state/selectors';
import { useAnalysisDefinitionStore } from '../state/useAnalysisDefinitionStore';
import type { UseAnalysisSourceCohortResult } from '../types';

// An analysis can reference multiple cohort sources (one per table column
// population); the Source cohort and Study period sections show the first one
// in the definition's `sources` map, read from the definition store so a staged
// (unsaved) cohort change is reflected immediately. Revisit once multi-cohort
// analyses need their own per-source study periods.
export const useAnalysisSourceCohort = (): UseAnalysisSourceCohortResult => {
  const { projectId, analysisVersionId } = useAnalysisRouteParams();

  const cohortProfileId = useAnalysisDefinitionStore(selectCohortProfileId);
  const loadedVersionId = useAnalysisDefinitionStore(selectLoadedVersionId);

  const { data: cohortList, isLoading: isCohortListLoading } = useCohortListQuery({
    projectId,
    enabled: Boolean(projectId) && Boolean(cohortProfileId),
  });

  const selectedCohort =
    cohortProfileId && cohortList
      ? cohortList.find((c) => c.cohortProfileId === cohortProfileId) ?? null
      : null;

  // "Loading" until the store reflects the URL's version, then while the
  // project cohort list joins onto the cohort id.
  const isHydrated = Boolean(analysisVersionId) && loadedVersionId === analysisVersionId;

  return {
    cohortProfileId,
    selectedCohort,
    isLoading: !isHydrated || (Boolean(cohortProfileId) && isCohortListLoading),
  };
};
